<template>
  <div class="vx-dialog--wrap" :style="{'z-index': zIndex}" @click.self="closeDialog" v-show="currentVisible">
    <div class="vx-dialog">
      <div class="vx-dialog--body">
        <div class="vx-dialog--title" v-if="title">{{title}}</div>
        <div class="vx-dialog--content" v-if="content" v-html="content"></div>
        <div class="vx-dialog--content" v-if="isSlot">
          <slot></slot>
        </div>
        <i
          class="vx-dialog--close"
          v-if="noFooter"
          @click.stop="closeDialog"
        ></i>
      </div>
      <template v-if="!noFooter">
        <div class="vx-dialog--footer" v-if="type == 'alert'">
          <button @click.stop="okBtnClick">{{okText}}</button>
        </div>
        <div class="vx-dialog--footer" v-else>
          <button
            class="btn cancel-btn"
            @click.stop="cancelBtnClick()"
          >{{cancelText}}</button>
          <button
            class="btn ok-btn"
            @click.stop="okBtnClick"
          >{{okText}}</button>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VxDialog',
  props: {
    type: {
      type: String,
      default: ''
    },
    zIndex: {
      type: Number,
      default: 1000
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    isSlot: {
      type: Boolean,
      default: false
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    },
    visible: {
      type: Boolean,
      default: false
    },
    noFooter: {
      type: Boolean,
      default: false
    },
    onOk: {
      default: null
    },
    onCancel: {
      default: null
    }
  },
  data() {
    return {
      currentVisible: false
    }
  },
  methods: {
    okBtnClick() {
      this.$emit('ok-btn-click')
      this.closeDialog(this.onOk)
    },
    cancelBtnClick() {
      this.$emit('cancel-btn-click')
      this.closeDialog(this.onCancel)
    },
    closeDialog(callback) {
      let stopClose = true
      if (typeof callback === 'function') {
        stopClose = callback()
        if (stopClose && stopClose instanceof Promise) {
          stopClose.then(() => {
            this.$emit('close')
            this.currentVisible = false
          })
        } else {
          if (stopClose === undefined) stopClose = true
          this.$emit('close')
          this.currentVisible = false
        }
      } else {
        this.$emit('close')
        this.currentVisible = false
      }
    }
  },
  watch: {
    visible: {
      handler(val) {
        this.currentVisible = val
      },
      immediate: true
    }
  }
}

</script>
<style lang="less">
@import './index.less';

</style>
